import { store } from '../store';
import {createApp} from 'vue'

if(document.querySelector('.p-book-shop')){
	var app_courses_module = createApp({
		data(){
			return {
				productList: [],
				productListNotEmpty: false,
				listOpen: false,
			}
		},
		computed: {
		},
		watch:{
		},
		mounted(){
			console.log('initializing book shop page');
			if (this.productList.length > 0) {
				this.productListNotEmpty = true;
			}
		},
		methods:{
			addProductToList: function(event){
				let target = event.currentTarget.closest('.c-file-list__item');
				let selector = target.querySelector('.c-file-list__item-dropdown');
				let sel = selector.querySelector('.c-select__field');
				let selected = sel.options[sel.selectedIndex];
				selector.classList.remove('c-select--error');
				if(sel.value){
					let prod = {
						id: target.dataset['id'],
						title: target.dataset['title'],
						img: target.dataset['img'],
						format: selected.getAttribute('data-format'),
						level: selected.getAttribute('data-type'),
						format_label: selected.getAttribute('data-format-label'),
						level_label: selected.getAttribute('data-type-label'),
						price: selected.getAttribute('data-price'),
						price_c: selected.getAttribute('data-price-col'),
						price_nc: selected.getAttribute('data-price-nocol'),
						sapCode: selected.getAttribute('data-sap-code'),
						prodCode: selected.getAttribute('data-prod-code'),
						prodId: selected.getAttribute('data-prod-id')
					}
					this.productList.push(prod);
					this.productListNotEmpty = true;
				}else{
					selector.classList.add('c-select--error');
				}
				
			},
			removeProductFromList: function(index){
				this.productList.splice(index);
				if (this.productList.length == 0) {
					this.productListNotEmpty = false;
					this.listOpen = false;
				}
			},
			toggleList: function(){
				this.listOpen = !this.listOpen;
			},
			goToCheckout: function(event){
				let url = event.currentTarget.dataset['url'];
				sessionStorage.setItem('checkoutProductsType', "books");
				sessionStorage.setItem('checkoutProducts', JSON.stringify(this.productList));
				window.location.href = url;
			}
		}
	}).mount(document.querySelector('.p-book-shop'));
} 